import { render, staticRenderFns } from "./camerasvg.vue?vue&type=template&id=65ec9a70"
import script from "./camerasvg.vue?vue&type=script&lang=js"
export * from "./camerasvg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports